export const environment = {
  appVersion: '1.02',
  ghoulPoolApi: 'https://ghoulishmortals-dev.warflix.net/api/',
  mmdApi: 'https://mmd-api-dev.warflix.net/api/v1',
  mmdApiRoot: 'https://mmd-api-dev.warflix.net',
  internalEmail: 'ghoulpool@ghoulishmortals.com',
  production: false,
  mainPageVideoURL: 'https://youtu.be/5kQuDgW1Gz0',
};
